export const G_DIVISIONS = "/goaliedivisions";
export const G_AVAILABILITY = "/goalieavailability";
export const G_CONTACT = "/goaliecontact";
export const G_SCHEDULE = "/goalieschedule";

export class GoalieAssignUrl {
  public static pattern = GoalieAssignUrl.createUrl(":gameId");

  static createUrl(gameId: number | string): string {
    return `/goalieassign/${gameId}`;
  }
}

export class GoalieAssignmentSeasonUrl {
  public static pattern = "/goalieassignmentseason/:division?";

  static createUrl(division?: string): string {
    return division ? `/goalieassignmentseason/${division}` : `/goalieassignmentseason`;
  }
}

export class GoalieStatsUrl {
  public static pattern = "/goaliestats/:division?";

  static createUrl(): string {
    return `/goaliestats`;
  }
}

export class GoalieGameHistoryUrl {
  public static pattern = "/goaliegamehistory/:division?";

  static createUrl(): string {
    return `/goaliegamehistory`;
  }
}
